module.exports = __webpack_public_path__ + "static/media/memory-card.297b68aa.png";